import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import { State, City } from "country-state-city";
import Select from "react-select";

const CreatePg = ({ setLoadModal }) => {
  const [floorOptions, setFloorOptions] = useState([]);
  const [floorRoomsList, setFloorRoomsList] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState("");
  const [numberOfRooms, setNumberOfRooms] = useState("");
  const [load, setLoad] = useState(false);
  const [calculatedTotalRooms, setCalculatedTotalRooms] = useState(0);
  const [allStates, setAllStates] = useState([]); //State for stroing all states
  const [allCities, setAllCities] = useState([]); //State for storing all cities
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nameBuilding: "",
      buildingType: "",
      pgType: "",
      pgAddress: "",
      city: "",
      state: "",
      pincode: "",
      ownerName: "",
      ownerPhoneNo: "",
      totalFloors: "",
      totalRooms: "",
      amenities: {
        airConditioner: false,
        internet: false,
        washingMachine: false,
        refrigerator: false,
        furnishedRooms: false,
        commonLoungeArea: false,
        bikeParking: false,
        carParking: false,
      },
      floorDetails: [{ floorNumber: "", numberOfRooms: "" }],
      rentAgreement: [],
      images: [],
      startingPrice: 0,
      mapLink: "",
      overview: "",
    },
  });

  // Define amenities list here
  const amenitiesList = [
    "airConditioner",
    "internet",
    "washingMachine",
    "refrigerator",
    "furnishedRooms",
    "commonLoungeArea",
    "bikeParking",
    "carParking",
  ];

  //Fetching all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  console.log("States: ", allStates);

  //Fetch cities when state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  //

  const onSubmit = async (data) => {
    setLoad(true);

    //Upload multiple Rent agreement img
    const rentAgreementFiles = Array.isArray(data.rentAgreement)
      ? data.rentAgreement
      : Array.from(data.rentAgreement || []);

    const rentAgreementUrl = rentAgreementFiles.length
      ? await Promise.all(
          rentAgreementFiles.map(async (file) => {
            try {
              return await uploadImg(file);
            } catch (error) {
              console.error("Failed to upload file:", file.name, error);
              return null; // Return null or a fallback value
            }
          })
        )
      : [];

    const imageFiles = Array.isArray(data.images)
      ? data.images
      : Array.from(data.images || []);

    const imageUrls = imageFiles.length
      ? await Promise.all(
          imageFiles.map(async (file) => {
            try {
              return await uploadImg(file);
            } catch (error) {
              console.log("Failed to upload file: ", file.name, error);
            }
          })
        )
      : [];

    const myData = {
      ...data,
      rentAgreement: rentAgreementUrl,
      floorDetails: floorRoomsList,
      totalRooms: calculatedTotalRooms,
      images: imageUrls,
    };

    console.log(myData);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/register_Building`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of createPg: ", response.data);
        toast.success(response.data.message);
        setLoadModal(false);
        setLoad(false);
        navigate(`/rooms_list/${response.data.data._id}`);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);

        setLoad(false);
      });
  };

  const totalFloors = watch("totalFloors");

  useEffect(() => {
    if (totalFloors) {
      const floorCount = parseInt(totalFloors, 10);
      setFloorOptions(Array.from({ length: floorCount }, (_, i) => i + 1));
    } else {
      setFloorOptions([]);
    }
  }, [totalFloors]);

  useEffect(() => {
    const total = floorRoomsList.reduce(
      (acc, floor) => acc + parseInt(floor.numberOfRooms, 10),
      0
    );
    setCalculatedTotalRooms(total);
  }, [floorRoomsList]);

  const handleAddFloorRooms = () => {
    if (selectedFloor && numberOfRooms) {
      setFloorRoomsList((prevList) => [
        ...prevList,
        { floorNumber: selectedFloor, numberOfRooms },
      ]);
      setSelectedFloor("");
      setNumberOfRooms("");
    }
  };

  const handleRemoveFloorRooms = (floorNumber) => {
    setFloorRoomsList((prevList) =>
      prevList.filter((item) => item.floorNumber !== floorNumber)
    );
  };

  // Determine which options are selectable based on the sequential requirement
  const nextSelectableFloor =
    floorRoomsList.length > 0
      ? floorRoomsList[floorRoomsList.length - 1].floorNumber + 1
      : 1;

  return (
    <div className="bg-black/50    backdrop-blur-sm fixed inset-0 w-full z-50 flex justify-center items-center ">
      <div className="p-8 lg:py-8 lg:px-16 relative overflow-auto h-[25rem] lg:h-[35rem] bg-white shadow-lg rounded-lg w-full max-w-5xl ">
        <h2 className="text-2xl font-semibold text-center mb-6">Add PG</h2>
        <AiFillCloseCircle
          onClick={() => {
            setLoadModal(false);
          }}
          className="cursor-pointer text-primaryColor absolute top-4 right-4 "
          size={30}
        />
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Name Of Building *
              </label>
              <input
                type="text"
                {...register("nameBuilding", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.nameBuilding ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Building Type *
              </label>
              <select
                {...register("buildingType", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.buildingType ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="">Select Type</option>
                <option value="Apartment">Apartment</option>
                <option value="Hostel">Hostel</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                PG Type *
              </label>
              <select
                {...register("pgType", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.pgType ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="">Select PG Type</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Address *
              </label>
              <input
                type="text"
                {...register("pgAddress", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.pgAddress ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            {/* State */}
            <div>
              <label
                htmlFor="state"
                className="text-sm font-medium text-primaryTextColor"
              >
                State *
              </label>
              <Select
                options={allStates}
                onChange={(option) => {
                  console.log("option", option);
                  setSelectedState(option);
                  setValue("state", option.label);
                }}
                required
                placeholder="Select State"
                className={`border ${
                  errors.state ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.state && (
                <span className="text-red-500 text-sm">
                  {errors.state.message}
                </span>
              )}
            </div>

            {/* City */}
            <div>
              <label
                htmlFor="city"
                className="text-sm font-medium text-primaryTextColor"
              >
                City *
              </label>

              <Select
                options={allCities}
                value={selectedCity}
                onChange={(option) => {
                  console.log("option in City: ", option);
                  setValue("city", option.value);
                }}
                required
                placeholder="Select your City"
                className={`border ${
                  errors.city ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.city && (
                <span className="text-red-500 text-sm">
                  {errors.city.message}
                </span>
              )}
            </div>

            {/* PIN Code  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Pin Code *
              </label>
              <input
                type="text"
                {...register("pincode", {
                  required: "PIN Code is required",
                  pattern: {
                    value: /^[1-9][0-9]{5}$/,
                    message: "Invalid PIN Code",
                  },
                })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.pincode ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 6);
                }}
              />
              {errors.pincode && (
                <span className="text-red-500 text-sm">
                  {errors.pincode.message}
                </span>
              )}
            </div>

            {/* Owner's Name  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Owner's Name *
              </label>
              <input
                type="text"
                {...register("ownerName", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.ownerName ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            {/* Owner's Contact No  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Owner's Contact No. *
              </label>
              <input
                type="text"
                {...register("ownerPhoneNo", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.ownerPhoneNo ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
            </div>

            <div>
              <label htmlFor="rentAgreement">Rent Agreement </label>

              <input
                type="file"
                id="rentAgreement"
                accept="image/*"
                {...register("rentAgreement")}
                multiple
              />
            </div>

            {/* Images  */}
            <div className="flex flex-col">
              <label
                htmlFor="images"
                className="block text-sm font-medium text-primaryTextColor mb-1"
              >
                Images *
              </label>

              <input
                type="file"
                id="images"
                accept="image/*"
                {...register("images")}
                multiple
              />
            </div>

            {/* Starting Price  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Starting Price *
              </label>
              <input
                type="text"
                {...register("startingPrice", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.startingPrice ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
              />
            </div>

            {/* Map Link  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Map Link *
              </label>
              <input
                type="text"
                {...register("mapLink", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.mapLink ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Total Floors *
              </label>
              <input
                type="number"
                {...register("totalFloors", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.totalFloors ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Total Number of Rooms *
              </label>
              <input
                type="number"
                value={calculatedTotalRooms} // Display calculated total
                readOnly // Make it non-editable
                className={`w-full border p-2 rounded-lg focus:outline-none bg-gray-200 border-gray-300`}
              />
            </div>

            {/* <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Total Number of Beds *
              </label>
              <input
                type="number"
                {...register("totalBeds", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.totalBeds ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div> */}
          </div>
          {floorOptions.length > 0 && (
            <div className="grid grid-cols-2 gap-3 bg-gray-200 p-3 rounded-lg ">
              <div>
                <label className="block text-sm font-medium text-primaryTextColor mb-1">
                  Floor Number
                </label>
                <select
                  value={selectedFloor}
                  onChange={(e) => setSelectedFloor(parseInt(e.target.value))}
                  className="w-full border p-2 rounded-lg focus:outline-none"
                >
                  <option value="">Select Floor</option>
                  {floorOptions.map((floor) => (
                    <option
                      key={floor}
                      value={floor}
                      disabled={
                        floorRoomsList.some(
                          (item) => item.floorNumber === floor
                        ) || floor > nextSelectableFloor
                      }
                      style={{
                        color: floorRoomsList.some(
                          (item) => item.floorNumber === floor
                        )
                          ? "#00f700"
                          : "black",
                      }}
                    >
                      Floor {floor}
                    </option>
                  ))}
                </select>
              </div>

              {selectedFloor && (
                <div>
                  <label className="block text-sm font-medium text-primaryTextColor mb-1">
                    Number of Rooms
                  </label>
                  <input
                    type="number"
                    value={numberOfRooms}
                    onChange={(e) =>
                      e.target.value <= 50
                        ? setNumberOfRooms(e.target.value)
                        : toast.error(
                            "Maximum 50 rooms can be added in a floor"
                          )
                    }
                    className="w-full border p-2 rounded-lg focus:outline-none"
                  />
                </div>
              )}
              {selectedFloor && (
                <button
                  type="button"
                  onClick={handleAddFloorRooms}
                  className="px-6 py-2 w-[6rem] float-right bg-primaryBtnColor text-white rounded-lg hover:via-primaryBtnHoverColor"
                >
                  Add
                </button>
              )}
            </div>
          )}

          {/* Displaying the floor rooms list */}
          {floorRoomsList.length > 0 && (
            <div className="mt-4 p-3 bg-gray-200 rounded-lg">
              <h3 className="text-lg font-semibold mb-2">Floor Room Details</h3>
              <ul className="list-disc pl-5 space-y-1">
                {floorRoomsList.sort().map((item, index) => (
                  <li key={index} className="flex items-center space-x-4">
                    <span>
                      Floor {item.floorNumber}: {item.numberOfRooms} Rooms
                    </span>
                    <button
                      type="button"
                      onClick={() => handleRemoveFloorRooms(item.floorNumber)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-primaryTextColor mb-1">
              Overview *
            </label>
            <textarea
              type="text"
              {...register("overview", { required: true })}
              className={`w-full border p-2 rounded-lg focus:outline-none ${
                errors.overview ? "border-red-500" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-primaryTextColor mb-1">
              Choose Amenities
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {amenitiesList.map((amenity) => (
                <label
                  key={amenity}
                  className="flex items-center space-x-2 text-gray-600"
                >
                  <Controller
                    name={`amenities.${amenity}`}
                    control={control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        {...field}
                        className="rounded text-blue-500 focus:ring-blue-500"
                      />
                    )}
                  />
                  <span className="capitalize">
                    {amenity.replace(/([A-Z])/g, " $1")}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex justify-between items-center gap-6">
            <button
              onClick={() => {
                setLoadModal(false);
              }}
              type="button"
              className="px-6 py-2 border w-[50%] border-gray-400 text-primaryTextColor rounded-lg hover:bg-secondaryTextColor focus:outline-none"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-primaryBtnColor w-[50%] text-white rounded-lg hover:bg-primaryBtnHoverColor focus:outline-none"
            >
              {"Submit"}
            </button>
          </div>
        </form>
      </div>
      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default CreatePg;
